export const convertStatusToAlias = (subtype) => {
	switch (subtype) {
		case 'active':
			return 'published';
		default:
			return subtype;
	}
};
